export enum FieldPivot {
  ROWS = 'ROWS',
  COLUMNS = 'COLUMNS',
  AGGREGATIONS = 'AGGREGATIONS',

  MAP_LAYER0 = 'MAP_LAYER0',
  MAP_LAYER1 = 'MAP_LAYER1',
  MAP_LAYER2 = 'MAP_LAYER2',
}
